import type { ReactNode } from 'react'
import Button, { type ButtonProps } from '@mui/material/Button'
import type { Falsy } from '@primitives/objects.utils'
import { joinButtonText } from '@primitives/string.utils'
import { type ConnectionProps, ConnectWalletButton } from '@ui/features/connect-wallet/ConnectWalletButton'
import { t } from '@ui/lib/i18n'
import { applySxProps } from '@ui/lib/mui'
import { useIsMobileFormDrawer } from '../form-context/FormPlacementContext'
import { BUTTON_FORM_SIZE } from './constants'

type FormButtonLabelPart = string | Exclude<Falsy, ''>

export type FormButtonProps = Pick<ButtonProps, 'disabled' | 'fullWidth' | 'loading' | 'sx'> & {
  children?: ReactNode
  connectWalletTestId?: string
  label?: string | FormButtonLabelPart[]
  pending?: boolean
  testId?: string
} & ConnectionProps

const fixedBottomSx = { position: 'fixed', bottom: 0, left: 0, right: 0 } as const

export const FormButton = ({
  children,
  connectWalletTestId,
  disabled,
  fullWidth,
  label,
  loading = false,
  pending = false,
  sx,
  testId,
  isConnecting,
  isConnected,
  connect,
}: FormButtonProps) => {
  const isMobileDrawer = useIsMobileFormDrawer()
  return isConnected ? (
    children || (
      <Button
        type="submit"
        disabled={disabled}
        fullWidth={isMobileDrawer || fullWidth}
        loading={loading ?? pending}
        size={BUTTON_FORM_SIZE}
        sx={applySxProps(sx, isMobileDrawer && fixedBottomSx)}
        data-testid={testId}
      >
        {pending ? t`Processing...` : Array.isArray(label) ? joinButtonText(...label) : label}
      </Button>
    )
  ) : (
    <ConnectWalletButton
      isConnecting={isConnecting}
      isConnected={isConnected}
      connect={connect}
      size={BUTTON_FORM_SIZE}
      fullWidth={isMobileDrawer || fullWidth}
      sx={applySxProps(sx, isMobileDrawer && fixedBottomSx)}
      testId={connectWalletTestId}
    />
  )
}
